import styled from 'styled-components';
import {
  AccordionSummary as MuiAccordionSummary,
  AccordionSummaryProps,
} from '@mui/material';
import { ReactComponent as ExpandIcon } from '../../assets/arrow-down-expand.svg';

type Props = AccordionSummaryProps & {
  iconPosition?: 'left' | 'right';
};

const ExpandIconStyled = styled(ExpandIcon)`
  width: 14px;
`;

const AccordionSummaryStyled = styled(MuiAccordionSummary)<{
  $iconPosition: 'left' | 'right';
}>`
  padding: 24px;
  height: 98px;
  flex-direction: ${({ $iconPosition }) =>
    $iconPosition === 'left' ? 'row-reverse' : 'row'};
  &.MuiAccordionSummary-root {
    border: 1px solid ${({ theme }) => theme.palette.common.gray13};
    border-color: ${({ theme }) => theme.palette.common.gray13};
    border-radius: 8px;
    transition: border-radius 0.5s;
  }

  &.MuiAccordionSummary-root.Mui-expanded {
    border-bottom: 1px solid ${({ theme }) => theme.palette.common.gray3};
    border-radius: 8px 8px 0 0;
    transition: border-radius 0s;
  }

  .MuiAccordionSummary-content {
    margin: 0;
    padding-left: ${({ $iconPosition }) =>
      $iconPosition === 'left' ? '24px' : undefined};
  }

  & .MuiAccordionSummary-expandIconWrapper {
    transform: rotate(-90deg);
  }

  & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(-180deg);
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.common.gray10};
  }
`;

const AccordionSummary = ({ iconPosition = 'left', ...props }: Props) => (
  <AccordionSummaryStyled
    expandIcon={<ExpandIconStyled />}
    $iconPosition={iconPosition}
    {...props}
  />
);

export default AccordionSummary;
